<div class="container">
  <div
    class="box p-2"
    [class.default]="type === alertType.Default"
    [class.success]="type === alertType.Success"
    [class.warning]="type === alertType.Warning"
    [class.error]="type === alertType.Error"
    [class.muted]="type === alertType.Muted"
    [class.info]="type === alertType.Info"
  >
    <div class="columns">
      <div class="column pr-0 is-narrow" *ngIf="hasIcon" [ngSwitch]="type">
        <span class="icon is-pulled-right">
          <em
            *ngSwitchCase="alertType.Warning"
            class="mdi mdi-alert mdi-24px"
            aria-hidden="true"
          ></em>
          <em
            *ngSwitchCase="alertType.Success"
            class="mdi mdi-checkbox-marked-circle mdi-18px"
            aria-hidden="true"
          ></em>
          <em
            *ngSwitchCase="alertType.Error"
            class="mdi mdi-close-circle mdi-24px"
            aria-hidden="true"
          ></em>
          <em *ngSwitchDefault class="mdi mdi-alert-circle mdi-18px" aria-hidden="true"></em>
        </span>
      </div>
      <div class="column">
        <div>
          <ng-content select="[title]"></ng-content>
        </div>

        <div *ngIf="description">
          <ng-content select="[description]"></ng-content>
        </div>

        <div class="pt-1" *ngIf="footer">
          <ng-content select="[footer]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
